<template>
	<div class='inspection-date'>
		<div class='date-block'>
			<!--<span class='label'>Дата проведения обследования </span> //uliana --> 
			<input type='date' v-model='lpoDate' :disabled='!actLpoIsDraft'>
		</div>

		<div class='vegetation-period-block'>
			<custom-p-checkbox v-model='is_vegetation' label='Указать срок вегетации' :disabled='!actLpoIsDraft'/>

			<div v-if='is_vegetation' class='vegetation-period-inputs-block'>
				<div class='vegetation-period-from-block'>
					<span class='label'>от</span>
					<input type='date' v-model='vegPeriodFrom' :disabled='!actLpoIsDraft'>
				</div>
				<div class='vegetation-period-to-block'>
					<span class='label'>до</span>
					<input type='date' v-model='vegPeriodTo' :disabled='!actLpoIsDraft'>
				</div>
			</div>

			<div class='vegetation-warning-block'>
				<b-alert v-if='needVegetationAlert' show variant="warning">Обследование проведено не в период вегетации</b-alert>
			</div>
		</div>



	</div>
</template>

<script>
	export default {
		name: 'InspectionDate',
		data: () => ({
			is_vegetation: false,
			is_vegetationChangedProgrammatically: false,
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			needVegetationAlert() {

	  		if (!this.lpo.vegetation_period_from) {
	  			return false;
	  		}

	  		if (!this.lpo.vegetation_period_to) {
	  			return false;
	  		}

	  		const date = new Date(this.lpo.inspection_date);
	  		const veg_from = new Date(this.lpo.vegetation_period_from);
	  		const veg_to = new Date(this.lpo.vegetation_period_to);

	  		if (date < veg_from || date > veg_to) {
	  			return true;
	  		}
	  		return false;
	  	},

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			lpoDate: {
				get() {
					return this.$store.state.selectedLpo.lpo.inspection_date;
				},
				set(value) {
					const valueList = [ { field: 'inspection_date', value: value } ];

					this.$store.dispatch('selectedLpo/saveLpoValue', valueList).then(res => {
						this.$store.dispatch('selectedLpo/updateLpo', valueList);
					});
				}
			},

			vegPeriodFrom: {
				get() {
					return this.$store.state.selectedLpo.lpo.vegetation_period_from;
				},
				set(value) {
					const valueList = [ { field: 'vegetation_period_from', value: value } ];

					this.$store.dispatch('selectedLpo/saveLpoValue', valueList).then(res => {
						this.$store.dispatch('selectedLpo/updateLpo', valueList);
					});
				}
			},
			vegPeriodTo: {
				get() {
					return this.$store.state.selectedLpo.lpo.vegetation_period_to;
				},
				set(value) {
					const valueList = [ { field: 'vegetation_period_to', value: value } ];

					this.$store.dispatch('selectedLpo/saveLpoValue', valueList).then(res => {
						this.$store.dispatch('selectedLpo/updateLpo', valueList);
					});
				}
			},
		},

		watch: {
			lpo() {
				this.resetValues();
			},

			is_vegetation(is_vegetation) {
				if (this.is_vegetationChangedProgrammatically) {
					this.is_vegetationChangedProgrammatically = false;
					return;
				}

				const valueList = [
					{ field: 'vegetation_period_to', value: null, },
					{ field: 'vegetation_period_from', value: null }
				];

				if (!is_vegetation) {
					this.$store.dispatch('selectedLpo/saveLpoValue', valueList).then(res => {
						this.$store.dispatch('selectedLpo/updateLpo', valueList);
					});
				}
			}
		},

		methods: {
			resetValues() {
				this.is_vegetationChangedProgrammatically = true;
				if (this.vegPeriodFrom || this.vegPeriodTo) {
					this.is_vegetation = true;
				}
			}
		},
		created() {
			this.resetValues();
		}
	};
</script>

<style scoped>
	.vegetation-period-block {
		margin-top: 10px;
	}

	.is-vegetation-label {
		vertical-align: top;
	}

	.vegetation-period-inputs-block {
		display: inline-block;
		margin-left: 21px;
	}

	.vegetation-period-from-block {
		margin-bottom: 4px;
	}

	.label {
		margin-right: 6px;
	}

	.vegetation-warning-block {
		margin-top: 1rem;
	}
</style>